const data = [
 
    { id: 1, name: "Criada" },
    { id: 2, name: "Iniciada" },
    { id: 3, name: "Parada" },
    { id: 4, name: "Finalizada" },
    { id: 5, name: "Resultado publicado" },
  ];
  
    
  export default [...data];
